import defer from '@ali/xutil/defer';
import {tryParse, tryStringify} from '@ali/xutil/json';
import * as Event from '@ali/xplugin/event-emitter';

let ee = new Event.EventEmitter();
let onDefers = {
  // page.balabala: Promise,
  // app.haha: Promise,
};
let offDefers = {
  // page.balabala: Promise,
  // app.haha: Promise,
};


if (typeof window !== 'undefined') {
  let win = window;
  let _onEventNotify = win.onEventNotify;

  win.onEventNotify = (sequence, ev, code, res, accountId) => {
    _onEventNotify && _onEventNotify(sequence, ev, code, res, accountId);
    res = tryParse(res);
    let onDefer = onDefers[ev];
    let offDefer = offDefers[ev];

    switch(code) {
      case 0: // 注册成功
        onDefer && onDefer.resolve();
        break;
      case 1: // 注册失败
        onDefer && onDefer.reject(res);
        delete onDefer[ev];
        break;
      case 2: // 事件通知
        ee.emit(ev, res);
        break;
      case 3: // 注销成功
        offDefer && offDefer.resolve();
        delete onDefers[ev];
        delete offDefers[ev];
        break;
      case 4: // 注销失败
        offDefer && offDefer.reject(res);
        break;
    }
  };
}

export function regEvent(X) {

  return function(ev, callback) {
    if (!onDefers[ev]) {
      onDefers[ev] = defer();
      workbench.regEvent(workbench.createSequenceId(), ev);
    }

    let deferred = onDefers[ev];
    return deferred.promise
      .then(() => {
        return ee.on(ev, callback);
      });
  };
}

export function unregEvent(X) {

  return function(ev, callback) {
    return ee.off(ev, callback)
      .then((result) => {
        let options = ee.optionsPool[ev];
        if (options.length > 0) return result;
        let deferred = offDefers[ev] = defer();
        workbench.unregEvent(workbench.createSequenceId(), ev);
        return deferred.promise;
      });
  };
}

export function postEvent(X) {

  return function(ev, data) {
    data = tryStringify(data || null);
    workbench.postEvent(ev, data);
    return Promise.resolve();
  };
}



// WEBPACK FOOTER //
// ./src/plugins/event.old.js